import { useState, useEffect , useRef } from 'react';
import { Spin } from 'antd';
import ChartComponent from '../../../../components/chart';
import Api from "../../../../services/api";
import {getBarSize, getColor} from '../../../../utility';
import ReChartComponent from "../../../../components/chartNew";

const AppChartCountry = (props) => {
  const [loading,setLoading] = useState(false);
	const [chartCountry,setChartCountry] = useState([]);
  const [chartCountryData,setChartCountryData] = useState({
  	labels : [],
  	datasets : []
  });

  const chartCountryOptions = {
    indexAxis: 'x',
    legend: false,
    flag: true
  };

  const prevParamsRef = useRef("");

  useEffect(() => {
    const currentParams = JSON.stringify({
      os: props.os,
      from: props.startDate.format('YYYY-MM-DD'),
      to: props.endDate.format('YYYY-MM-DD'),
      code: props.code,
      country: props.country,
      ad_network: props.adnetwork,
      campaign: props.campaign,
      index_filter: props.filter
    });

    if (prevParamsRef.current === currentParams) return;

    prevParamsRef.current = currentParams;

    setLoading(true)
    Api.get(`api/overview_app/cost_by_country?os=${props.os}&from=${props.startDate.format('YYYY-MM-DD')}&to=${props.endDate.format('YYYY-MM-DD')}&code=${props.code}&country=${props.country}&ad_network=${props.adnetwork}&campaign=${props.campaign}&index_filter=${props.filter}`)
    .then(result => {
      if(result?.data?.code === 0){
        setChartCountry(result.data.data)
        setLoading(false)
      }
    });
  }, [props.code,props.os,props.reload,props.filter]);

  useEffect(() => {
    let labels = [];
    let datasets = [{
      label: `${props.startDate.format('YYYY-MM-DD')} - ${props.endDate.format('YYYY-MM-DD')}`,
      data: [],
      backgroundColor: [],
      barThickness : getBarSize
    }];

    chartCountry.map((i,k) => {
  		labels.push(i.name)
      datasets[0].data.push(i.value)
      datasets[0].backgroundColor.push(getColor(k))
  	})

    setChartCountryData({labels,datasets})
  }, [chartCountry]);

  return (
    <Spin spinning={loading}>
      {/* <ChartComponent type="bar" data={chartCountryData} options={chartCountryOptions} /> */}
      <ReChartComponent 
        type="bar" 
        data={{
          ...chartCountryData, 
          originalData: chartCountry 
        }} 
        options={chartCountryOptions} 
        height={250} 
      />
    </Spin>
  )
}
export default AppChartCountry;
